import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CONTACT } from "@/data/site";

const LINKS = [
  { label: "Home", to: "/", id: "home" },
  { label: "Programs", to: "/programs", id: "programs" },
  { label: "The Science", to: "/science", id: "science" },
  { label: "Contact", to: "/inquire", id: "contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 border-b border-[#E2ECEE] bg-white/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-2.5 lg:px-8">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img
            src="/playlab-logo.png"
            alt="SplayLab"
            className="logo-glow h-16 w-auto transition-transform hover:scale-[1.04] sm:h-20"
          />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.id}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.id}`}
              className={({ isActive }) =>
                `relative text-[15px] font-extrabold transition-colors after:absolute after:-bottom-1.5 after:left-0 after:h-1 after:rounded-full after:bg-[#F97316] after:transition-all after:duration-300 ${
                  isActive
                    ? "text-[#0E9E96] after:w-full"
                    : "text-slate-600 hover:text-[#0E9E96] after:w-0 hover:after:w-full"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <a
            href={CONTACT.phoneHref}
            data-testid="nav-phone"
            className="hidden items-center gap-2 rounded-full border-2 border-[#0E9E96] px-4 py-2 text-sm font-extrabold text-[#0E9E96] transition-colors hover:bg-[#0E9E96]/5 md:flex"
          >
            <Phone className="h-4 w-4" />
            {CONTACT.phone}
          </a>
          <Button
            data-testid="nav-quote-btn"
            onClick={() => navigate("/inquire")}
            className="rounded-full bg-[#F97316] px-5 font-extrabold text-white shadow-md transition-all hover:bg-[#ea6a0c] hover:shadow-lg"
          >
            Request Quote
          </Button>
          <button
            data-testid="nav-mobile-toggle"
            className="grid h-10 w-10 place-items-center rounded-xl border border-[#E2ECEE] lg:hidden"
            onClick={() => setOpen((o) => !o)}
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-[#E2ECEE] bg-white px-5 py-4 lg:hidden">
          <div className="flex flex-col gap-3">
            {LINKS.map((l) => (
              <NavLink
                key={l.id}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className="text-sm font-extrabold text-slate-700"
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
